import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PageLoader from "../components/common/PageLoader/PageLoader";

import Home from "../pages/Home/Home";

const AboutPage = lazy(() => import("../pages/About/About"));
const Services = lazy(() => import("../pages/Services/Services"));
const DrillingServices = lazy(() => import("../pages/Services/DrillingServices/DrillingServices"));
const WorkoverCompletion = lazy(() => import("../pages/Services/WorkoverCompletion/WorkoverCompletion"));
const OAndM = lazy(() => import("../pages/Services/o&m/OAndM"));
const OilfieldEquipment = lazy(() => import("../pages/Services/OilfieldEquipment/OilfieldEquipment"));
const ManpowerSupply = lazy(() => import("../pages/Services/ManpowerSupply/ManpowerSupply"));
const Projects = lazy(() => import("../pages/Projects/Projects"));
const Equipment = lazy(() => import("../pages/Equipment/Equipment"));
const Clients = lazy(() => import("../pages/Clients/Clients"));
const Careers = lazy(() => import("../pages/Careers/Careers"));
// const Media = lazy(() => import("../pages/Media/Media"));
// const Blogs = lazy(() => import("../pages/Media/blogs/Blogs"));
// const News = lazy(() => import("../pages/Media/news/News"));
const Gallery = lazy(() => import("../pages/Gallery/Gallery"));
const Contacts = lazy(() => import("../pages/Contact/Contact"));
const AwardsAndRecognitions = lazy(() => import("../pages/awardsAndRecognitions/AwardsAndRecognitions"));
const Industries = lazy(() => import("../pages/Industries/Industries"));
const PrivacyPolicy = lazy(() => import("../pages/Legal/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("../pages/Legal/TermsOfUse"));
const CookiePolicy = lazy(() => import("../pages/Legal/CookiePolicy"));
const NotFound = lazy(() => import("../pages/NotFound/NotFound"));
const HSEQ = lazy(() => import("../pages/hseq/HSEQ"));
const GWS = lazy(() => import("../pages/gws/GWS"));
const MajorMilestone = lazy(() => import("../pages/majormilestone/MajorMilestone"));
function AppRoutes() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/drilling" element={<DrillingServices />} />
        <Route path="/services/workover-completion" element={<WorkoverCompletion />} />
        <Route path="/services/oam" element={<OAndM />} />
        <Route path="/services/equipment" element={<OilfieldEquipment />} />
        <Route path="/services/manpower" element={<ManpowerSupply />} />
        <Route path="/recruitment" element={<Navigate to="/services/manpower" replace />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/industries/:slug" element={<Navigate to="/about" replace />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/equipment" element={<Equipment />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/careers" element={<Careers />} />
        {/* <Route path="/media" element={<Media />} /> */}
        {/* <Route path="/media/blogs" element={<Blogs />} />
        <Route path="/media/news" element={<News />} /> */}
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/awards-and-recognitions" element={<AwardsAndRecognitions />} />
        <Route path="/credentials" element={<Navigate to="/awards-and-recognitions" replace />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/hseq" element={<HSEQ />} />
        <Route path="/gws" element={<GWS />} />
        <Route path="/major-milestone" element={<MajorMilestone />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
